import { createSlice } from "@reduxjs/toolkit";
import { deleteNylas } from "features/nylas/actions";
import { 
  getProfile,
  updateProfile
 } from './actions';

export const initialState = {
  manager: { 
    id: '', 
    clinic: { 
      nylas_account_id: null, 
      widget_token: '' 
    }, 
    email: '', 
    first_name: '', 
    last_name: '', 
    updated_at: '' 
  },
  loading: false
};

const  slice = createSlice({
  name: 'profile',
  initialState,
  extraReducers(builder) {
    builder
      .addCase(getProfile.pending, (state) => {
        state.loading = true;
      })
      .addCase(getProfile.fulfilled, (state, action) => {
        const { manager } = action.payload;
        
        state.loading = false;
        state.manager = { ...state.manager, ...manager };
      })
      .addCase(getProfile.rejected, (state) => {
        state.loading = false;
      })
      .addCase(updateProfile.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateProfile.fulfilled, (state, action) => {
        const { status, manager } = action.payload;
        const updatedManager = { ...state.manager, ...manager };
        
        state.loading = false;
        if (status === 204) {
          state.manager = updatedManager;
        };   
      })
      .addCase(updateProfile.rejected, (state) => {
        state.loading = false;
      })
      .addCase(deleteNylas.fulfilled, (state, action) => {
        const { status } = action.payload;
        
        if (status === 204) {
          state.manager = {
            ...state.manager,
            clinic: { ...state.manager.clinic, nylas_account_id: null }
          }
        }
      })
  }
})

export default slice.reducer;